// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIcon, Checkbox, Group, Skeleton, Text, Tooltip } from '@mantine/core';
import { useContext } from 'react';
import { IconRefresh, IconSettings } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { ICalContext } from '../../../Service/Context/ICalContext';
import { ExternalSubscription } from '../../../Types/CalDavT';
import BookingStateItem from '../BookingStateItem';
import EmptyText from '../../../Atoms/EmptyText';
import { GoogleCalendarDto } from '../../../Types/GoogleT';
import { ThemeText } from '../../../Atoms/ThemeText';

const ExternalCalendarsSelection = () => {
  const { loading, subscriptions, googleCalendars, refreshExternalICal, showTasks, setShowTasks } =
    useContext(ICalContext);
  const navigate = useNavigate();
  const isEmpty = !loading && subscriptions.length === 0 && googleCalendars.length === 0;

  const googleCalendarItemUI = (cal: GoogleCalendarDto) => {
    const { calendarId: id, calendarName: name, backgroundColor: color } = cal;
    return <BookingStateItem key={id} active label={name} color={color} textColor="inherit" />;
  };

  const calendarItemUI = (cal: ExternalSubscription) => {
    const { id, name, color, healthy } = cal;
    return (
      <BookingStateItem
        key={id}
        active
        label={name}
        color={color}
        textStyle={{ textDecoration: healthy ? 'none' : 'line-through' }}
        icon={
          !healthy ? (
            <Tooltip
              multiline
              position="bottom-end"
              transition="slide-down"
              label="Der Kalender konnte nicht abgerufen werden. Bitte prüfe deine Kalender-Einstellungen."
            >
              <div>⚠️</div>
            </Tooltip>
          ) : (
            <ActionIcon>
              <IconRefresh size={16} onClick={() => refreshExternalICal(cal)} />
            </ActionIcon>
          )
        }
      />
    );
  };

  return (
    <>
      <Group mt="xl" position="apart" mb="xs" pr={10}>
        <ThemeText pl={10}>Private Kalender</ThemeText>
        <ActionIcon onClick={() => navigate('/settings/calendar')}>
          <IconSettings size={16} />
        </ActionIcon>
      </Group>
      {loading && <Skeleton width="100%" height={200} />}
      {!loading && isEmpty && <EmptyText mt="xs" ml="md" />}
      {!loading && subscriptions.map(calendarItemUI)}
      {!loading && googleCalendars.map(googleCalendarItemUI)}
      <ThemeText mt="xl" pl={10}>
        Optionen
      </ThemeText>
      <Checkbox
        mt="sm"
        ml="md"
        label="Aufgaben anzeigen"
        checked={showTasks}
        onChange={() => setShowTasks(!showTasks)}
      />
    </>
  );
};

export default ExternalCalendarsSelection;
